import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// --- PWA: register service worker ---
// Only register in production-like origins (skip on localhost dev to avoid HMR conflicts).
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const isLocal = ['localhost', '127.0.0.1'].includes(window.location.hostname);
    if (isLocal) return;
    navigator.serviceWorker.register('/sw.js', { scope: '/' })
      .then((reg) => {
        // Force an immediate update check so users on a stale cache pick up
        // the freshest SW right after a deploy.
        reg.update().catch(() => {});
        // When a new SW takes control, reload the tab once so hashed JS chunks
        // aren't fetched against the previous HTML shell.
        let didReload = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (didReload) return;
          didReload = true;
          window.location.reload();
        });
        // Also check for updates when the tab regains focus
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') reg.update().catch(() => {});
        });
      })
      .catch((err) => console.debug('SW registration failed', err));
  });
}
